class FellowsLeaders {
	constructor(element) {
		element.querySelectorAll('[data-fellows-card]').forEach((card) => {
			this.bindCard(card);
		});
	}

	bindCard(card) {
		const toggle = card.querySelector('[data-fellows-toggle]');
		const bio = card.querySelector('[data-fellows-bio]');
		if (!toggle || !bio) return;

		const label = toggle.querySelector('.fellows-leaders__toggle-label');
		const labelMore = toggle.dataset.labelMore || 'Read more';
		const labelLess = toggle.dataset.labelLess || 'Read less';

		let pendingEnd = null;
		const clearPendingEnd = () => {
			if (!pendingEnd) return;
			bio.removeEventListener('transitionend', pendingEnd);
			pendingEnd = null;
		};

		toggle.addEventListener('click', () => {
			clearPendingEnd();

			const willExpand = !card.classList.contains('is-expanded');
			card.classList.toggle('is-expanded', willExpand);
			toggle.setAttribute('aria-expanded', String(willExpand));
			if (label) {
				label.textContent = willExpand ? labelLess : labelMore;
			}

			const targetPx = `${bio.scrollHeight}px`;

			if (willExpand) {
				bio.style.maxHeight = targetPx;
				pendingEnd = (event) => {
					if (event.propertyName !== 'max-height') return;
					clearPendingEnd();
					bio.style.maxHeight = 'none';
				};
				bio.addEventListener('transitionend', pendingEnd);
				return;
			}

			bio.style.maxHeight = targetPx;
			void bio.offsetHeight;
			requestAnimationFrame(() => {
				bio.style.maxHeight = '';
			});
		});
	}

	static init() {
		document.querySelectorAll('[data-component="fellows-leaders"]').forEach((element) => {
			new FellowsLeaders(element);
		});
	}
}

export default FellowsLeaders;
